var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowIc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    color: "#212121",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.3281 24.3203C33.3281 24.7633 32.9989 25.1294 32.5719 25.1873L32.4531 25.1953L14.9531 25.1953C14.4699 25.1953 14.0781 24.8036 14.0781 24.3203C14.0781 23.8773 14.4073 23.5112 14.8344 23.4533L14.9531 23.4453L32.4531 23.4453C32.9364 23.4453 33.3281 23.8371 33.3281 24.3203Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.633 30.7281C22.9755 31.0691 22.9766 31.6231 22.6357 31.9656C22.3257 32.2769 21.8397 32.3062 21.4966 32.0527L21.3982 31.9682L14.3399 24.9402C14.0277 24.6293 13.9993 24.1415 14.2547 23.7984L14.3399 23.7002L21.3982 16.671C21.7406 16.33 22.2946 16.3312 22.6356 16.6736C22.9456 16.9849 22.9729 17.471 22.718 17.8131L22.6331 17.911L16.1977 24.3205L22.633 30.7281Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowIc);
export default __webpack_public_path__ + "static/media/arrow_ic.3816e7299f90f62873c1addc106d37b1.svg";
export { ForwardRef as ReactComponent };